/* eslint-disable @typescript-eslint/no-explicit-any */
import useInfiniteQuery from '@/service-library/core-hooks/useInfiniteQuery'
import useZerapixTable, { ZerapixTableOptions } from './useZerapixTable'

type UseInfiniteScrollTableOptions<DataType extends Record<string, any>> =
  ZerapixTableOptions<DataType> & {
    query: ReturnType<typeof useInfiniteQuery>
  }

export default function useInfiniteScrollZerapixTable<
  DataType extends Record<string, any>,
>({ query, ...options }: UseInfiniteScrollTableOptions<DataType>) {
  const { isPending, isFetchingNextPage, isFetchingPreviousPage, isLoading } =
    query

  return useZerapixTable<DataType>({
    ...options,
    state: {
      ...options.state,
      showSkeletons: isPending,
      showProgressBars:
        isLoading || isFetchingNextPage || isFetchingPreviousPage,
    },
  })
}
